module.exports = __webpack_public_path__ + "static/media/om_hairstyle_wavy_back_vector.a2bf8530.svg";